import React, { useEffect, useState } from "react";
import {
    Layout,
    Typography,
    Breadcrumb,
    Select,
    Button,
    Table,
    Row,
    Col,
    Space,
    Spin,
    Form,
    Card
} from "antd";
import { ClearOutlined, FileExcelOutlined, SearchOutlined } from "@ant-design/icons";
import Headerdiv from "../../layout/header.js";
import Footerdiv from "../../layout/footer.js";
import { APPBACKGROUND_COLOR, MAINAPIURL } from "../../appsettings.js";
import axios from "axios";
import { AlertError } from "../../usableclasses.js";
import { Link } from "react-router-dom";
import { handleMLMUserReportExportToExcel } from "./mlm-user-report-excel.js";

const { Title } = Typography;
const { Content } = Layout;
const { Option } = Select;

const columns = [
    { title: "Consultant ID", dataIndex: "consultid", key: "consultid" },
    { title: "Level", dataIndex: "level", key: "level" },
    { title: "First Name", dataIndex: "firstname", key: "firstname" },
    { title: "Second Name", dataIndex: "secondname", key: "secondname" },
    { title: "Self Point", dataIndex: "monthselfponit", key: "monthselfponit" },
    { title: "Group Point", dataIndex: "monthgroupponit", key: "monthgroupponit" },
    { title: "Self BV", dataIndex: "monthselfbv", key: "monthselfbv" },
    { title: "Group BV", dataIndex: "monthgroupbv", key: "monthgroupbv" },
    { title: "Wallet Balance", dataIndex: "monthwalletbalance", key: "monthwalletbalance" },
    { title: "Reg Doc Type", dataIndex: "regdoctype", key: "regdoctype" },
    { title: "Reg Doc No", dataIndex: "regdocno", key: "regdocno" },
    { title: "Reg Doc Verify", dataIndex: "regdocverify", key: "regdocverify" },
    { title: "Mobile", dataIndex: "usermobile", key: "usermobile" },
    { title: "User Email", dataIndex: "useremail", key: "useremail" },
    { title: "Bank Name", dataIndex: "bankname", key: "bankname" },
    { title: "Branch Name", dataIndex: "branchname", key: "branchname" },
    { title: "Bank Acc No", dataIndex: "bankaccno", key: "bankaccno" },
    { title: "Bank Acc Name", dataIndex: "bankaccname", key: "bankaccname" },
    { title: "Bank Verify", dataIndex: "bankverify", key: "bankverify" },
    { title: "Bill Address 1", dataIndex: "billaddR1", key: "billaddR1" },
    { title: "Bill Address 2", dataIndex: "billaddR2", key: "billaddR2" },
    { title: "Bill City", dataIndex: "billcity", key: "billcity" },
    { title: "Bill District", dataIndex: "billdistrict", key: "billdistrict" },
    { title: "Ship Address 1", dataIndex: "shipaddR1", key: "shipaddR1" },
    { title: "Ship Address 2", dataIndex: "shipaddR2", key: "shipaddR2" },
    { title: "Ship City", dataIndex: "shipcity", key: "shipcity" },
    { title: "Ship District", dataIndex: "shipdistrict", key: "shipdistrict" },
    { title: "Need PW Reset", dataIndex: "needpwreset", key: "needpwreset", render: v => v ? "Yes" : "No" },
    { title: "User Verify", dataIndex: "userverify", key: "userverify", render: v => v ? "Yes" : "No" },
    { title: "User Active", dataIndex: "useractive", key: "useractive", render: v => v ? "Yes" : "No" },
    { title: "Created Date", dataIndex: "creatE_DT", key: "creatE_DT" },
    { title: "Last Change Date", dataIndex: "lastchangE_DT", key: "lastchangE_DT" },
];

const MLMUserReport = () => {
    const ApiURL = MAINAPIURL;
    const TOKEN = localStorage.getItem("AUTHCODE");
    const [isLoading, setIsLoading] = useState(false);
    const [userList, setUserList] = useState([]);
    const [status, setStatus] = useState("ALL");

    const fetchUserList = async (statusValue = status) => {
        try {
            setIsLoading(true);
            const headers = { SystemAccessToken: TOKEN };
            const res = await axios.get(`${ApiURL}/reports/mlm/userlist/${statusValue}`, { headers });
            setUserList(res.data);
        } catch (error) {
            AlertError("Failed to Load MLM User List");
        } finally {
            setIsLoading(false);
        }
    };


    const handleExportToExcel = () => {
        handleMLMUserReportExportToExcel(userList, status);
    };

    return (
        <Spin spinning={isLoading} tip="Processing...">
            <Layout style={{ backgroundColor: APPBACKGROUND_COLOR }}>
                <Headerdiv />
                <Content style={{ padding: "10px" }}>
                    <Breadcrumb style={{ margin: "16px 0" }}>
                        <Breadcrumb.Item><Link to={"/reports"}>Reports</Link></Breadcrumb.Item>
                        <Breadcrumb.Item>MLM User Details Report</Breadcrumb.Item>
                    </Breadcrumb>
                    <Card style={{ marginBottom: 20 }} title={
                        <Row align="middle" justify="space-between">
                            <Col span={12}>
                                <Title level={3} style={{ textAlign: 'left', margin: 0 }}>MLM User Details Report</Title>
                            </Col>
                            <Col span={12} style={{ textAlign: 'right' }}>
                                <Space>
                                    <Button
                                        disabled={userList.length === 0}
                                        type="primary"
                                        icon={<FileExcelOutlined />}
                                        onClick={handleExportToExcel}
                                        style={{ backgroundColor: "#28a745", borderColor: "#28a745" }}
                                    >
                                        Export to Excel
                                    </Button>
                                </Space>
                            </Col>
                        </Row>
                    }>
                        <Form layout="inline" style={{ width: '100%' }} onFinish={() => fetchUserList(status)}>
                            <Row align="middle" gutter={[16, 16]} style={{ width: '100%' }}>
                                <Col xs={24} sm={12} md={6}>
                                    <Form.Item label="Status" style={{ marginBottom: 0 }}>
                                        <Select
                                            style={{ width: '100%' }}
                                            value={status}
                                            onChange={value => setStatus(value)}
                                            options={[
                                                { value: "ALL", label: "ALL" },
                                                { value: "ACTIVE", label: "ACTIVE" },
                                                { value: "DEACTIVE", label: "DEACTIVE" },
                                            ]}
                                        />
                                    </Form.Item>
                                </Col>
                                <Col xs={24} sm={12} md={3} style={{ display: 'flex', alignItems: 'end' }}>
                                    <Button 
                                    htmlType="submit" 
                                    type="primary"
                                    icon={<SearchOutlined/>}
                                     style={{ width: '100%' }}>Get Data</Button>
                                </Col>
                                <Col xs={24} sm={12} md={3} style={{ display: 'flex', alignItems: 'end' }}>
                                    <Button
                                        style={{ width: '100%' }}
                                        icon={<ClearOutlined />}
                                        onClick={() => {
                                            setStatus("ALL");
                                            setUserList([]);
                                        }}
                                    >
                                        Clear
                                    </Button>
                                </Col>
                            </Row>
                        </Form>
                    </Card>
                    <Card title="MLM Users" style={{ marginBottom: 20 }}>
                        <Table
                            style={{ marginTop: 20 }}
                            columns={columns}
                            dataSource={userList}
                            pagination={false}
                            bordered
                            scroll={{ x: "max-content" }}
                            rowKey={record => record.consultid}
                        />
                    </Card>
                </Content>
                <Footerdiv />
            </Layout>
        </Spin>
    );
};

export default MLMUserReport;
